import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { calculators, textTools } from "../data/tools";
import { AdSlot } from "../components/AdSlot";
import { usePageMeta } from "../lib/usePageMeta";

const Grid = ({ items, base }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 border-t-2 border-l-2 border-ink">
    {items.map((t) => {
      const Icon = t.icon;
      return (
        <Link
          key={t.slug}
          to={`/${base}/${t.slug}`}
          data-testid={`${base}-index-${t.slug}`}
          className="group border-b-2 border-r-2 border-ink bg-paper p-8 hover:bg-canvas transition-colors relative flex gap-5 items-start"
        >
          <span className="w-12 h-12 shrink-0 border-2 border-ink bg-canvas flex items-center justify-center group-hover:bg-klein group-hover:text-paper transition-colors">
            <Icon className="w-6 h-6" strokeWidth={2.2} />
          </span>
          <div>
            <h3 className="font-heading font-bold text-2xl tracking-tight">{t.title}</h3>
            <p className="text-sm text-ink/60 mt-1">{t.blurb}</p>
          </div>
          <ArrowRight className="w-5 h-5 absolute top-8 right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
        </Link>
      );
    })}
  </div>
);

export function CalculatorsIndex() {
  usePageMeta("Calculators — BMI, Loan, Percentage & Age | Utiliverse", "Free online calculators: BMI, percentage, loan/EMI and age calculators.");
  return (
    <div>
      <section className="bp-grid border-b-2 border-ink">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-signal mb-3">Tool Category</p>
          <h1 className="font-heading font-black text-5xl sm:text-6xl tracking-tighter">Calculators</h1>
          <p className="mt-4 text-lg text-ink/70 max-w-2xl">Quick answers for everyday math — health, money and dates.</p>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12">
        <Grid items={calculators} base="calculators" />
        <div className="mt-12"><AdSlot format="leaderboard" testid="calculators-ad" /></div>
      </div>
    </div>
  );
}

export function TextToolsIndex() {
  usePageMeta("Text Tools — Word Counter, Case Converter & More | Utiliverse", "Free online text tools: word counter, case converter, password generator and lorem ipsum.");
  return (
    <div>
      <section className="bp-grid border-b-2 border-ink">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-signal mb-3">Tool Category</p>
          <h1 className="font-heading font-black text-5xl sm:text-6xl tracking-tighter">Text Tools</h1>
          <p className="mt-4 text-lg text-ink/70 max-w-2xl">Manipulate, measure and generate text in a click.</p>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12">
        <Grid items={textTools} base="text-tools" />
        <div className="mt-12"><AdSlot format="leaderboard" testid="text-tools-ad" /></div>
      </div>
    </div>
  );
}
